import emojiRegexPkg from 'emoji-regex';

const regexFromPackage = emojiRegexPkg();

export const countEmoji = (input?: string) => {
  const result = input?.match(regexFromPackage);
  return result?.length ?? 0;
};

export const removeEmoji = (input?: string) => {
  const result = input?.replace(regexFromPackage, '');
  return result ?? undefined;
};
